import React, { Children } from 'react'

import { Col, Grid } from '../structure/Grid'
import ConditionalLink from '../actions/ConditionalLink'
import Icon from '../shapes/Icon'
import Text from './Text'

const LogoText = ({ logo, logoLeft, logoRight, label, iconColor, iconSize, gutter, gap, path, onClick, ...props }) => {
  logoLeft = logoLeft || logo

  return (
    <ConditionalLink onClick={onClick} path={path} block {...props}>
      <Grid gap={gap || gutter || 0.5} align="center">
        {logoLeft && <Col>{logoLeft}</Col>}
        <Text size="small" {...props}>
          {label}
        </Text>
        {logoRight && <Col>{logoRight}</Col>}
      </Grid>
    </ConditionalLink>
  )
}

export default LogoText
